import React from 'react'

function getThumbnailStyle(width, height) {
  const ratio = width / height
  const maxWidth = 44
  const maxHeight = 28

  if (ratio >= 1) {
    return {
      width: `${maxWidth}px`,
      height: `${Math.min(maxHeight, Math.max(16, Math.round(maxWidth / ratio)))}px`,
    }
  }

  return {
    width: `${Math.max(16, Math.round(maxHeight * ratio))}px`,
    height: `${maxHeight}px`,
  }
}

function sanitizeSizeValue(value) {
  const digits = String(value ?? '').replace(/[^\d]/g, '')
  return digits.slice(0, 5)
}

export default function PreviewSizeControl({
  previewSizePreset,
  setPreviewSizePreset,
  previewCustomSize,
  setPreviewCustomSize,
  previewDimensions,
  presets,
}) {
  const updateCustomSize = (dimension, nextValue) => {
    setPreviewSizePreset('custom')
    setPreviewCustomSize((current) => ({
      ...current,
      [dimension]: sanitizeSizeValue(nextValue),
    }))
  }

  const applyPreset = (preset) => {
    setPreviewSizePreset(preset.id)
    setPreviewCustomSize({
      width: String(preset.width),
      height: String(preset.height),
    })
  }

  return (
    <div className="workflow-preview-size-control">
      <div className="workflow-preview-size-control__label">Size preset</div>
      <div className="workflow-preview-size-control__scroller">
        {presets.map((preset) => {
          const isActive = previewSizePreset === preset.id

          return (
            <button
              key={preset.id}
              type="button"
              className={[
                'workflow-preview-size-card',
                isActive ? 'is-active' : '',
              ].join(' ')}
              onClick={() => applyPreset(preset)}
            >
              <span
                className="workflow-preview-size-card__thumb"
                style={getThumbnailStyle(preset.width, preset.height)}
                aria-hidden="true"
              />
              <span className="workflow-preview-size-card__copy">
                <strong>{preset.label}</strong>
                <small>
                  {preset.width}×{preset.height}
                </small>
              </span>
            </button>
          )
        })}

        <div
          className={[
            'workflow-preview-size-card',
            'workflow-preview-size-card--custom',
            previewSizePreset === 'custom' ? 'is-active' : '',
          ].join(' ')}
        >
          <span className="workflow-preview-size-card__custom-icon" aria-hidden="true">
            ⛶
          </span>
          <div className="workflow-preview-size-card__custom-inputs">
            <input
              type="text"
              inputMode="numeric"
              aria-label="Custom preview width"
              value={previewCustomSize?.width ?? ''}
              onFocus={() => setPreviewSizePreset('custom')}
              onChange={(event) => updateCustomSize('width', event.target.value)}
            />
            <span>×</span>
            <input
              type="text"
              inputMode="numeric"
              aria-label="Custom preview height"
              value={previewCustomSize?.height ?? ''}
              onFocus={() => setPreviewSizePreset('custom')}
              onChange={(event) => updateCustomSize('height', event.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="workflow-preview-size-control__caption">
        Current preview: {previewDimensions?.width} × {previewDimensions?.height} px
      </div>
    </div>
  )
}
